import { Directive, ElementRef, HostListener, Input, Renderer2, inject } from '@angular/core';

@Directive({
  selector: '[appTooltipIfTruncated]',
  standalone: true
})
export class TooltipIfTruncatedDirective {
  @Input() appTooltipIfTruncated: string = '';
  private elementRef: ElementRef = inject(ElementRef);
  private renderer: Renderer2 = inject(Renderer2);

  @HostListener('mouseenter')
  checkTruncation() {
    const element: HTMLElement = this.elementRef.nativeElement;
    const isTruncated: boolean = element.scrollWidth > element.offsetWidth;

    if (isTruncated) {
      this.renderer.setAttribute(element, 'title', this.appTooltipIfTruncated);
      return;
    }
    this.renderer.removeAttribute(element, 'title');
  }
}